import { useState } from "react";
import { Card, Tabs, useMantineTheme } from "@mantine/core";
import RevenueFees from "./RevenueFees";
import OrganizationDetail from "./Detail";
import { useAppContext } from "src/api/AppContext";
import CustomBranding from "./CustomBranding";
import { useParams } from "react-router-dom";
import { useGetOrganizationQuery } from "src/generated/graphql";
import OrganizationSettings from "./OrganizationSettings";

export enum TabsName {
  DETAILS = "Organization Details",
  REVENUE_FEES = "Revenue and Fees",
  CUSTOM_BRANDING = "Custom Branding",
  ORGANIZATION_SETTINGS = "Organization Settings",
}

const OrganizationDetails = () => {
  const { currentAdmin, currentOrganization, setCurrentOrganization } =
    useAppContext();
  const theme = useMantineTheme();
  let border = `solid ${theme.colors.primary[6]}`;
  let bg = theme.colors.secondary[2];
  let color = theme.colors.secondaryTextColor[6];

  const [currentTab, setCurrentTab] = useState<TabsName>(TabsName.DETAILS);
  const updateTab = (tabName: TabsName) => {
    setCurrentTab(tabName);
  };

  const { orgId = "" } = useParams();
  const {
    data: organizationData,
    loading,
    refetch,
  } = useGetOrganizationQuery({
    variables: {
      id: orgId,
    },
    onCompleted(data) {
      if (data.organizationOne && orgId === currentOrganization?.id) {
        setCurrentOrganization(data.organizationOne);
      }
    },
  });

  return (
    <Card
      style={{
        //border: `1px ${border}`,
        color,
        overflow: "hidden",
      }}
      radius="md"
      w="100%"
      p={0}
      bg="transparent"
    >
      <Tabs
        styles={{
          tabsList: {
            //borderBottom: `3px ${border}`,
            color,
            padding: "0 15px",
          },
          tab: {
            marginBottom: -2.5,
            fontWeight: 500,
            borderBottomWidth: 3,
          },
          panel: {
            padding: 15,
          },
        }}
        value={currentTab}
        onTabChange={updateTab}
      >
        <Tabs.List bg={bg}>
          {Object.values(TabsName)
            .filter((tab) => tab !== TabsName.REVENUE_FEES || currentAdmin?.id)
            .map((e) => (
              <Tabs.Tab
                key={e}
                value={e}
                style={{
                  color: theme.colors.secondaryTextColor[2],
                }}
                sx={{
                  "&:hover": {
                    color: `${theme.colors.primary[4]} !important`,
                    borderColor: `${theme.colors.primary[4]} !important`,
                  },
                }}
              >
                {e}
              </Tabs.Tab>
            ))}
        </Tabs.List>

        <Tabs.Panel value={TabsName.DETAILS}>
          <OrganizationDetail
            organizationOne={organizationData?.organizationOne}
            loading={loading}
            refetch={refetch}
          />
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.REVENUE_FEES}>
          {currentTab === TabsName.REVENUE_FEES && <RevenueFees />}
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.CUSTOM_BRANDING}>
          {currentTab === TabsName.CUSTOM_BRANDING && (
            <CustomBranding
              organizationOne={organizationData?.organizationOne}
              loading={loading}
              refetch={refetch}
            />
          )}
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.ORGANIZATION_SETTINGS}>
          {currentTab === TabsName.ORGANIZATION_SETTINGS && (
            <OrganizationSettings
              organizationId={organizationData?.organizationOne?.id}
            />
          )}
        </Tabs.Panel>
      </Tabs>
    </Card>
  );
};

export default OrganizationDetails;
